// import axios from 'axios'
// export default axios.create({
// 	baseURL: process.env.VUE_APP_QUESTOES_API
// })

import axios from 'axios'
const instance = axios.create({
	baseURL: process.env.VUE_APP_QUESTOES_API,
	headers: {
		'Content-Type': 'application/json'
	}
})

instance.interceptors.request.use(config => {
	config.headers['questoes-token'] = localStorage.getItem('repov4-token')
	return config
})

export default instance
